// useKitchenStock.js
import { useState, useCallback } from 'react';
import kitchenStockApi from './kitchenStockApi';

export const useKitchenStock = (kindergartenId) => {
  const [balance, setBalance] = useState([]);
  const [batches, setBatches] = useState([]);
  const [movements, setMovements] = useState([]);
  const [expiring, setExpiring] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const runLoad = useCallback(async (loaderFn, setter) => {
    setLoading(true);
    setError(null);
    try {
      const data = await loaderFn();
      setter(data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadBalance = useCallback(
    () => runLoad(() => kitchenStockApi.getBalance(kindergartenId), setBalance),
    [kindergartenId, runLoad]
  );

  const loadBatches = useCallback(
    (filter) => runLoad(() => kitchenStockApi.getBatches(kindergartenId, filter), setBatches),
    [kindergartenId, runLoad]
  );

  const loadMovements = useCallback(
    (filter) => runLoad(() => kitchenStockApi.getMovements(kindergartenId, filter), setMovements),
    [kindergartenId, runLoad]
  );

  const loadExpiring = useCallback(
    (daysAhead) => runLoad(() => kitchenStockApi.getExpiring(kindergartenId, daysAhead), setExpiring),
    [kindergartenId, runLoad]
  );

  const receive = useCallback(async (data) => {
    setError(null);
    await kitchenStockApi.addReceipt({ ...data, kindergartenId });
  }, [kindergartenId]);

  const writeOff = useCallback(async (data) => {
    setError(null);
    await kitchenStockApi.writeOff({ ...data, kindergartenId });
  }, [kindergartenId]);

  return {
    balance,
    batches,
    movements,
    expiring,
    loading,
    error,
    actions: { loadBalance, loadBatches, loadMovements, loadExpiring, receive, writeOff }
  };
};

export default useKitchenStock;
